import {
  Component,
  OnInit,
  Input,
  ElementRef,
  EventEmitter,
  Output,
} from '@angular/core';
import { AssistanceTicket } from '../../../../models/assistanceticket';
import { AssistanceProvider } from '../../../../models/assistance-provider';
import { ConfService } from '../../../../services/conf.service';
import { ApiService } from '../../../../api/api.service';
import { DistancecalculService } from '../../../../services/distancecalcul.service';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { IamService } from '../../../../services/iam.service';
import { MeService } from 'src/app/services/me.service';
import { MessageService } from 'primeng/api';
import { LoaderService } from 'src/app/api/loader.service';
import { ClaimService } from 'src/app/services/buca/claim.service';
import { Chip } from 'src/app/models/chip';

@Component({
    selector: 'app-assistance-letterauthorization',
    templateUrl: './assistance-letterauthorization.component.html',
    styleUrls: ['./assistance-letterauthorization.component.css'],
    providers: [MessageService],
    standalone: false
})
export class AssistanceLetterauthorizationComponent implements OnInit {
  //cartas
  @Input() titular_name: any;

 @Input() case_id: any;
 @Input() opcion: any;
 @Input() cost_: any = '';
 @Input() country_id: any;
 @Input() services_group: any;
 @Input() provider:any;
 @Input() dental_letter: boolean = false;
 @Input() patient_data: any;

 @Input() assistancecase;
 //fin cartas
 case_service_id=new EventEmitter<number>();
 @Input() applicant_name : EventEmitter<string>;
 @Input() applicant_id : EventEmitter<number>;
 @Input() country : EventEmitter<number>;
 @Input() case_provider_id : EventEmitter<number>;
 @Input() Ticket: EventEmitter<AssistanceTicket>;
 @Input() provider_name_ : EventEmitter<any>;
 @Input() provider_address_ : EventEmitter<any>;
 @Output() getLetter = new EventEmitter();
 

  id_Category;
  @Input() service_idd: EventEmitter<any>;
  editprovider: AssistanceProvider;
  providers_app = new EventEmitter<any>();
  editticket: AssistanceTicket;
  subtypes: any;
  types: any;
  service_id: number;
  hasUsers = false;
  html = '';
  emails = '';
  comment = '';
  namepatient = '';
  identificationnumber = '';
  description = '';
  coordinatedby = '';
  daynhour = '';
  branch = '';
  responsible = '';
  cost = '';
  activateemail = false;
  observation = '';
  Category = '';
  SubCategory = '';
  direccion = '';
  agente = '';
  tel = '';
  cartas = false;

  //vet
  nombre_centro;
  especificar;
  nombre_mascota;
  peso;
  edad;
  raza;

  buca_data: any = null;
  appointmentDate: any;
  changeAppointmentDate: boolean = false;

  filter: any = {
    id: null,
  };

  chipsCabinContactPhones: Chip[] = [];
  chipsProvidersCabinContactPhones: Chip[] = [];

  answers: any;
  answers_text: any;

  constructor(
    public el: ElementRef,
    public conf: ConfService,
    private api: ApiService,
    private distapi: DistancecalculService,
    private translate: TranslateService,
    private me: MeService,
    private messageService: MessageService,
    private claimService: ClaimService,
    private iam: IamService,
    private loaderService: LoaderService
  ) {}

  ngOnInit() {
    this.api.assistancesales
      .get_subtype()
      .promise()
      .then((resp) => {
        this.subtypes = resp;
      });

    
  
    
    
    
    
    if(this.provider){
      
      this.getAnswers(this.case_id);

      this.branch = this.provider ? this.provider.name : ''
      this.direccion = this.provider ? this.provider.address : ''
      let date = this.provider ? this.provider.date?.split('T') : ''
      if (date) {
        this.daynhour = date[0]+' '+date[1].slice(0, 8)
      }
    }

    this.api.assistancesales.get_subtype().promise()
    .then((resp) => {
      this.subtypes = resp
     
    });

    this.api.assistancesales.get_types().promise()
    .then((resp) => {
      this.types = resp
     
    });

    if(this.opcion == 5){
      this.loaderService.display(true);
      this.api.buca
        .getLetterInformation(this.case_id)
        .promise()
        .then((data) => {
          this.loaderService.display(false);
          this.buca_data = data;
          this.appointmentDate = null;

          this.chipsCabinContactPhones = [];
          this.chipsProvidersCabinContactPhones = [];

          if (this.buca_data.cabin_contact_phones) {
            this.chipsCabinContactPhones = this.buca_data.cabin_contact_phones
              .split(',')
              .map((phone) => {
                return { value: phone };
              });
          }

          if (this.buca_data.providers_cabin_contact_phones) {
            this.chipsProvidersCabinContactPhones =
              this.buca_data.providers_cabin_contact_phones
                .split(',')
                .map((phone) => {
                  return { value: phone };
                });
          }
        });
    }

    this.api.me
      .get()
      .promise()
      .then((data) => {
        this.me.updateToken(data);
        this.agente = data.name;
      })
      .catch((e) => {
        
      });

    if (this.country_id == 1) {
      this.tel = '22135585';
    } else if (this.country_id == 2) {
      this.tel = '44041185';
    } else if (this.country_id == 3) {
      this.tel = '22838835';
    } else if (this.country_id == 4) {
      this.tel = '22251585';
    } else if (this.country_id == 5) {
      this.tel = '78315385';
    } else if (this.country_id == 6) {
      this.tel = '8337570';
    }

  if (this.provider_address_) {
    this.provider_address_.subscribe(data=>{
      
      
      this.direccion = String(data)
    })
  }

  if (this.provider_name_) {
    this.provider_name_.subscribe(data=>{
      
      
      
      this.branch = String(data)
    })
  }
  this.Category = this.services_group[0]?.service.category.name; 
  this.SubCategory = this.services_group[0]?.service.name;

    if (this.provider_address_) {
      this.provider_address_.subscribe((data) => {
        this.direccion = data;
      });
    }

    if (this.provider_name_) {
      this.provider_name_.subscribe((data) => {
        this.branch = data;
      });
    }
  }

  async getAnswers(assistance_case_id){
    this.api.assistanceSaleAnswers
      .get(assistance_case_id)
      .promise()
      .then((response) => {
        this.answers = response;
        this.answers_text = this.answers
          .map(item => `${item.question_text}: ${item.answer_text}`)
          .join(' ');

        const regex_namepatient = /Nombre del paciente: (.*?)\s\d/;
        const match = this.answers_text.match(regex_namepatient);
        this.namepatient = match ? match[1].trim() : '';
        if(!this.namepatient && this.patient_data['patient']) this.namepatient = this.patient_data['patient'];
        
        this.responsible = this.opcion == 2 ? 'Afiliado paga el 100%':'Salud Primero'
  
        const regex_idpatient = /ID del Paciente(?:\s*\(.*?\))?:\s*(.+)/i;
        const match_id = this.answers_text.match(regex_idpatient);
        this.identificationnumber = match_id ? match_id[1].trim() : ''
        if(!this.identificationnumber && this.patient_data['identification']) this.identificationnumber = this.patient_data['identification'];

        if(this.opcion == 4) {
          for(let answer of this.answers) {
            if(answer.question_text.includes('Nombre de la mascota')) this.nombre_mascota = answer.answer_text
            else if(answer.question_text.includes('Raza')) this.raza = answer.answer_text
            else if(answer.question_text.includes('Edad de la mascota')) this.edad = answer.answer_text
            else if(answer.question_text.includes('Peso aproximado')) this.peso = answer.answer_text
          }
        }
        
      })
      .catch((e) => {
        this.loaderService.display(false);
      });
  }

  reset() {
    this.editticket = new AssistanceTicket();
  }

  Generarcarta() {

    this.loaderService.display(true);

    const filter = Object.assign({}, this.filter);
    filter['case_id'] = this.case_id;
    filter['nombre_titular'] = this.titular_name;
    filter['telefono'] = this.tel;
    filter['namepatient'] = this.namepatient;
    filter['identificationnumber'] = this.identificationnumber;
    filter['description'] = this.description;
    filter['coordinatedby'] = this.coordinatedby;
    filter['daynhour'] = this.daynhour;
    filter['branch'] = this.branch;
    filter['responsible'] = this.responsible;
    if (this.cost_) {
      filter['cost'] = this.cost_;
    } else {
      filter['cost'] = '';
    }

    filter['observation'] = this.observation;
    filter['usuario_asesor'] = this.agente;
    filter['tipo_servicio'] = this.Category;

    filter['subcategory'] = this.SubCategory;
    filter['agente'] = this.agente;
    filter['direccion'] = this.direccion;
    filter['opcion'] = this.opcion;

    filter['nombre_centro'] = this.nombre_centro;
    filter['especificar'] = this.especificar;
    filter['nombre_mascota'] = this.nombre_mascota;
    filter['peso'] = this.peso;
    filter['edad'] = this.edad;
    filter['raza'] = this.raza;
    filter['dental_letter'] = this.dental_letter

    this.api.assistancecases
      .createletter()
      .filter(filter)
      .promise()
      .then((users) => {

        this.activateemail = true;
        this.loaderService.display(false);
        this.messageService.add({
          severity: 'info',
          summary: 'Info',
          detail: 'Carta Generada',
        });
        
        this.getLetter.emit();
      })
      .catch((e) => {

        this.activateemail = false;
        this.loaderService.display(false);
        let apiError = '';

        try {
          let err = JSON.parse(e._body);
          apiError = err.error;
        } catch (e) {
          apiError = '';
        }

        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${e.error} ${apiError}`,
        });
      });
  }

  onSelectCategory(id) {
    this.id_Category = id;
  }

  Enviarcartaprov() {
    this.loaderService.display(true);
    this.cartas = true; 

    const filter = Object.assign({}, this.filter);
    filter['correos'] = this.emails;
    filter['case_id'] = this.case_id;
    filter['nombre_titular'] = this.titular_name;
    filter['telefono'] = this.tel;
    filter['namepatient'] = this.namepatient;
    filter['identificationnumber'] = this.identificationnumber;
    filter['description'] = this.description;
    filter['coordinatedby'] = this.coordinatedby;
    filter['direccion'] = this.direccion;
    filter['daynhour'] = this.daynhour;
    filter['branch'] = this.branch;
    filter['responsible'] = this.responsible;
    filter['cost'] = this.cost_;
    filter['observation'] = this.observation;
    filter['agente'] = this.agente;
    filter['tipo_servicio'] = this.Category;
    filter['opcion'] = this.opcion;
    filter['subcategory'] = this.SubCategory;
    filter['nombre_centro'] = this.nombre_centro;
    filter['especificar'] = this.especificar;
    filter['nombre_mascota'] = this.nombre_mascota;
    filter['peso'] = this.peso;
    filter['edad'] = this.edad;
    filter['raza'] = this.raza;
    filter['dental_letter'] = this.dental_letter
    this.api.assistancecases
      .sendletteremail()
      .filter(filter)
      .promise()
      .then((users) => {
        this.loaderService.display(false);
        this.messageService.add({
          severity: 'info',
          summary: 'Info',
          detail: 'Carta Enviada',
        });
      })
      .catch((e) => {
        this.loaderService.display(false);
        let apiError = '';

        try {
          let err = JSON.parse(e._body);
          apiError = err.error;
        } catch (e) {
          apiError = '';
        }

        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${e.error} ${apiError}`,
        });
      });
  }

  saveAppointmentDate() {
    let dataToSend = {
      case: this.buca_data.case,
      appointment_date: this.appointmentDate,
    };

    this.loaderService.display(true);
    this.api.buca
      .modifyAppointmentDate(dataToSend)
      .promise()
      .then((response) => {
        this.buca_data.time = response['time'];
        this.buca_data.date = response['date'];
        this.loaderService.display(false);
        this.modifyAppointmentDate();

        this.messageService.add({
          severity: 'info',
          summary: 'Info',
          detail: 'Fecha y hora de cita modificada en Buca',
        });
      })
      .catch((e) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail:
            'Se produjo un error al modificar la fecha y hora de cita en Buca',
        });

        this.loaderService.display(false);
        this.modifyAppointmentDate();
      });
  }

  modifyAppointmentDate() {
    this.appointmentDate = null;
    this.changeAppointmentDate = !this.changeAppointmentDate;
  }

  donwloadConfirmationLetter() {
    this.claimService.downloadPdf(this.buca_data);
  }

  sendConfirmationLetter() {
    this.loaderService.display(true);
    this.api.buca
      .sendConfirmationLetter(this.buca_data)
      .promise()
      .then((resonse) => {
        this.loaderService.display(false);
        this.messageService.add({
          severity: 'info',
          summary: 'Info',
          detail: 'Carta de confirmación enviada.',
        });
      })
      .catch((e) => {
        this.loaderService.display(false);
        let error_msg = '';
        try {
          error_msg = e.error.error;
          this.translate.get(error_msg).subscribe((res: string) => {
            error_msg = res;
          });
        } catch {
          error_msg = e.error;
        }

        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${error_msg}`,
        });
      });
  }
}
